import { Layout, SlideoutDecorator, SlideoutDecoratorProps,  ClickEvent, SaveButton } from "@mcleod/components";
import { AutogenLayoutFuelPriceTable } from "./autogen/AutogenLayoutFuelPriceTable";
import { Api } from "@mcleod/core";

export class FuelPriceTable extends AutogenLayoutFuelPriceTable {
    
    public static showInSlideoutDecorator(props?: Partial<SlideoutDecoratorProps>): SlideoutDecorator {
        const layout = Layout.getLayout("lme/general/FuelPriceTable") as FuelPriceTable;
        return new SlideoutDecorator({
            layout: layout,
            width: "75%",
            fillVerticalSpace: true,
            addlComponents: layout.saveButton,
            title: "Fuel Prices",
            ...props
        })
    }    
    
    private saveButton: SaveButton = SaveButton.create({
        id: "saveButton",
        caption: "Save",
        rowBreak: false,
        allowSave: true,
        onClick: async (event: ClickEvent) => {
            this.saveButton.busy = true;
            await Promise.all([
                this.tableWeekly.rows.map(row => row.data.post()),
                this.tableMonthly.rows.map(row => row.data.post()),
            ]).finally(() => {
                this.saveButton.busy = false;
            });
        }
    })

    /** This is an event handler for the onClick event of buttonRefreshPrices. */
    buttonRefreshPricesOnClick(event: ClickEvent) {
        this.buttonRefreshPrices.busy = true;
        Api.post("lme/general/refresh-fuel-prices").then((_) => {
            this.sourceFuelPrice.search();
            this.sourceFuelPriceMonthly.search();
        }).finally(() => {
            this.buttonRefreshPrices.busy = false;
        });
    }
}
